import styled from 'styled-components';
import { themeContract } from './ProgressBar.theme.contract';
var Container = styled.div.withConfig({
  displayName: "ProgressBarstyles__Container",
  componentId: "sc-7s0bj4-0"
})(["display:flex;padding-top:10px;padding-bottom:10px;"]);
var BarContainer = styled.span.withConfig({
  displayName: "ProgressBarstyles__BarContainer",
  componentId: "sc-7s0bj4-1"
})(["position:relative;background:", ";height:", "px;border-radius:36px;flex-grow:1;"], function (props) {
  return props.theme.color.monochrome.light;
}, function (props) {
  return props.height;
});
var Bar = styled.span.withConfig({
  displayName: "ProgressBarstyles__Bar",
  componentId: "sc-7s0bj4-2"
})(["position:absolute;height:100%;width:", ";transition:width 2s;min-width:", "px;background-color:", ";border-radius:36px;"], function (props) {
  return props.width;
}, function (props) {
  return props.height;
}, function (props) {
  return props.theme.color.palette[props.color === 'primary' || props.color === 'secondary' ? themeContract[props.theme.channel].color[props.color] : props.color];
});
var SegmentDivider = styled.span.withConfig({
  displayName: "ProgressBarstyles__SegmentDivider",
  componentId: "sc-7s0bj4-3"
})(["height:100%;width:1px;background-color:", ";opacity:", ";position:absolute;left:", "%;"], function (props) {
  return props.segmentDividerColor === 'primary' || props.segmentDividerColor === 'secondary' ? props.theme.color.palette[themeContract[props.theme.channel].color[props.segmentDividerColor]] : props.theme.color.monochrome[props.segmentDividerColor];
}, function (props) {
  return props.opacity;
}, function (props) {
  return props.position;
});
var Count = styled.span.withConfig({
  displayName: "ProgressBarstyles__Count",
  componentId: "sc-7s0bj4-4"
})(["margin-left:10px;font-size:", ";line-height:", "px;color:", ";width:", "px;"], function (props) {
  return props.theme.font.size.caption;
}, function (props) {
  return props.lineHeight - 3;
}, function (props) {
  return props.theme.color.monochrome.base;
}, function (props) {
  return props.width * 6;
});
export { Container, BarContainer, Bar, Count, SegmentDivider };